"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentInfosToJSON = exports.ShipmentInfosFromJSONTyped = exports.ShipmentInfosFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentInfosFromJSON(json) {
    return ShipmentInfosFromJSONTyped(json, false);
}
exports.ShipmentInfosFromJSON = ShipmentInfosFromJSON;
function ShipmentInfosFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shipmentList': !(0, runtime_1.exists)(json, 'shipmentList') ? undefined : (json['shipmentList'].map(_1.ShipmentInfosShipmentListFromJSON)),
        'nextDataId': !(0, runtime_1.exists)(json, 'nextDataId') ? undefined : json['nextDataId'],
    };
}
exports.ShipmentInfosFromJSONTyped = ShipmentInfosFromJSONTyped;
function ShipmentInfosToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shipmentList': value.shipmentList === undefined ? undefined : (value.shipmentList.map(_1.ShipmentInfosShipmentListToJSON)),
        'nextDataId': value.nextDataId,
    };
}
exports.ShipmentInfosToJSON = ShipmentInfosToJSON;
//# sourceMappingURL=ShipmentInfos.js.map